module.exports = "https://www.gc-pro.gnp.com.mx/752c415befd5eae7369e8640b5fc5b46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/appstore.svg
// module id = 8058
// module chunks = 0